/**
 * Data de abertura gravada em dd/MM/yyyy (Brasil) ou yyyy-MM-dd.
 * `new Date("02/12/2026")` lê mês/dia e mostraria 12/02/2026.
 */

export function parseDataAbertura(dateString) {
  if (dateString == null) return null;
  const s = String(dateString).trim();
  if (!s || /^n[ãa]o\s+/i.test(s) || s === 'null' || s === 'undefined') return null;

  const br = s.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/);
  if (br) {
    const dia = Number(br[1]);
    const mes = Number(br[2]);
    const ano = Number(br[3]);
    if (mes < 1 || mes > 12 || dia < 1 || dia > 31) return null;
    const d = new Date(ano, mes - 1, dia, 12, 0, 0, 0);
    if (d.getFullYear() !== ano || d.getMonth() !== mes - 1 || d.getDate() !== dia) return null;
    return d;
  }

  if (/^\d{4}-\d{2}-\d{2}$/.test(s)) {
    const [ano, mes, dia] = s.split('-').map(Number);
    const d = new Date(ano, mes - 1, dia, 12, 0, 0, 0);
    if (d.getFullYear() !== ano || d.getMonth() !== mes - 1 || d.getDate() !== dia) return null;
    return d;
  }

  const d = new Date(s);
  return Number.isNaN(d.getTime()) ? null : d;
}

export function formatarDataAbertura(dateString) {
  const d = parseDataAbertura(dateString);
  if (!d) return '';
  const dd = String(d.getDate()).padStart(2, '0');
  const mm = String(d.getMonth() + 1).padStart(2, '0');
  return `${dd}/${mm}/${d.getFullYear()}`;
}
